<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/agentperformance/info"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
      :goback="true"
      :showDownloadPower="true"
      showDownloadPowerType="warning"
      downloadPowerText="导出"
      downloadPower="/agentperformance/export"
      @down="down"
    >
      <el-form-item label="购买人ID">
        <el-input v-model="formModel.buyUserId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="购买人手机号">
        <el-input v-model="formModel.buyPhone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
          style="width: 300px"
          v-model="formModel.orderNo"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="购买日期">
        <el-date-picker
          v-model="formModel.date"
          type="month"
          value-format="yyyy-MM"
          format="yyyy-MM"
          placeholder="选择月"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="orderNo"
        label="订单号"
        :formatter="formatterTableData"
        min-width="360"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="buyUserId"
        label="购买人ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="buyPhone"
        label="购买人手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="buyName"
        label="购买人姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="performanceUserId"
        label="上级ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="performancePhone"
        label="上级手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="performanceName"
        label="上级姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="performancePartnerLevel"
        label="上级合伙人"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="performance"
        label="业绩"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createDate"
        label="购买日期"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="orderTime"
        label="订单日期"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import OrganService from "service/OrganService";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "agentperformancedetails",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        buyUserId: "",
        buyPhone: "",
        orderNo: "",
        date: "",
      },
      tableData: [],
      submitService: OrganService.agentperformancedetailsList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  created() {
    this.impiementall = JSON.parse(this.$route.params.item);
  },
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      const params = {
        userId: this.impiementall.agentId,
        buyUserId: this.formModel.buyUserId,
        buyPhone: this.formModel.buyPhone,
        date: this.formModel.date,
        orderNo: this.formModel.orderNo,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        date: this.impiementall.createTime,
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    down() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "export",
            "8885",
            "/shareplan/t-performance-dtl/"
          )
        : "";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/AgentPerformanceDetails.vue